/**
 * `:::tabs` のタブ切り替え（05_ui.md §6.3 / 08_directive-syntax.md §4.3）。
 *
 * 表示状態（aria-selected / パネルの hidden）はサーバー出力時点で確定しているため、
 * 初期化ではロービングタブインデックス（tabIndex）のみを設定し、表示状態は書き換えない
 * （プログレッシブエンハンスメント。04_sequence.md §7）。
 */

function warnIfMismatch(condition: boolean, message: string): void {
  if (!condition) {
    console.warn(`[lms-tabs] ${message}`);
  }
}

function select(tabs: HTMLButtonElement[], panels: HTMLElement[], index: number, focus: boolean): void {
  tabs.forEach((tab, i) => {
    const isSelected = i === index;
    tab.setAttribute("aria-selected", String(isSelected));
    tab.tabIndex = isSelected ? 0 : -1;
  });
  panels.forEach((panel, i) => {
    panel.hidden = i !== index;
  });
  if (focus) {
    tabs[index]?.focus();
  }
}

function initSingle(root: HTMLElement): void {
  if (root.dataset["lmsTabsReady"] === "1") return;
  root.dataset["lmsTabsReady"] = "1";

  const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>("[data-lms-tab]"));
  const panels = Array.from(root.querySelectorAll<HTMLElement>("[data-lms-tabpanel]"));
  if (tabs.length === 0) return;

  warnIfMismatch(tabs[0]?.getAttribute("aria-selected") === "true", "index0のタブがaria-selected=trueではありません");
  panels.forEach((panel, index) => {
    warnIfMismatch(panel.hidden === (index !== 0), "パネルの初期表示状態がサーバー出力と一致しません");
  });

  tabs.forEach((tab, index) => {
    tab.tabIndex = tab.getAttribute("aria-selected") === "true" ? 0 : -1;

    tab.addEventListener("click", () => select(tabs, panels, index, false));
    tab.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowRight":
          e.preventDefault();
          select(tabs, panels, (index + 1) % tabs.length, true);
          break;
        case "ArrowLeft":
          e.preventDefault();
          select(tabs, panels, (index - 1 + tabs.length) % tabs.length, true);
          break;
        case "Home":
          e.preventDefault();
          select(tabs, panels, 0, true);
          break;
        case "End":
          e.preventDefault();
          select(tabs, panels, tabs.length - 1, true);
          break;
        default:
          break;
      }
    });
  });
}

export function initTabs(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLElement>("[data-lms-tabs]").forEach((root) => {
    initSingle(root);
  });
}
